<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div class="btn-box">
        <button-add @click="showAddScene = true" v-if="permissionCodes.indexOf('005004002') !== -1" />
      </div>
      <input-search placeholder="场景名称" @search="searchKey" />
    </div>
    <table-main :selection="false" :tableHead="tableHead" :tableData="tableData" @deleteLine="deleteLine" @changeSelection="changeSelection" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" :operationArr="operationArr" />


    <el-dialog title="添加场景" :visible.sync="showAddScene" width="500px">
      <el-form style="width: 360px;margin: 0 auto;" @submit.native.prevent>
        <el-form-item label="场景名称" label-width="120px">
          <el-input v-model="newSceneName" size="small" style="width: 220px;" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showAddScene = false" size="small">取 消</el-button>
        <el-button type="primary" @click="confirm" size="small">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";

import ButtonDelete from "../../../components/Button/ButtonDelete";
import ButtonExport from "../../../components/common/buttons/button-export";
import ButtonUpload from "../../../components/common/buttons/button-upload";
import InputSearch from "../../../components/Input/InputSearch";
import InputSelect from "../../../components/Input/InputSelect";
import TableMain from "../../../components/Table/TableMain";
import { api } from "../../api/ElectronicManagement";
import { errorHandler } from "../../../utils/errorHandler";
import { nAlert, nError, nSuccess } from "../../../utils/notice";
import { bus } from "../../../utils/bus";
import ButtonAdd from "../../../components/common/buttons/button-add";

export default {
  components: {
    ButtonAdd,
    TableMain,
    InputSelect,
    InputSearch,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    Breadcrumb
  },
  name: "device-scene-config",
  data() {
    return {
      permissionCodes: "",
      breadcrumb: [
        {
          value: "智慧用电",
          name: "electronic-over-view"
        },
        {
          value: "场景配置"
        }
      ],
      addController: "controller-add",
      exportUrl: "",
      tableHead: [
        {
          prop: "name",
          label: "场景名称"
        }
      ],
      tableData: [],
      total: 0,
      pageSize: 10,
      pageNum: 1,
      showAddScene: false,
      newSceneName: "",
      selectionArr: [],
      requestData: {
        searchKey: ""
      },
      operationArr: ["delete"]
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
    this.getPage();
  },
  activated() {
    this.getPage();
  },
  methods: {
    // 获取设备场景
    getPage() {
      let reqData = this.requestData;
      reqData.pageNum = this.pageNum;
      reqData.pageSize = this.pageSize;
      this.$axios
        .post(api.getElectricScenePage, reqData)
        .then(res => {
          let data = res.data.data.list;
          this.total = res.data.data.total;
          this.tableData = data;
        })
        .catch(errorHandler("获取信息失败"));
    },
    search(v) {
      this.requestData[v.key] = v.value;
      this.getPage();
    },
    searchKey(v) {
      this.pageNum = 1;
      this.requestData.searchKey = v;
      this.getPage();
    },
    changePagination(data) {
      this.pageNum = data[0];
      this.pageSize = data[1];
      this.getPage();
    },
    changeSelection(codeArr) {
      this.selectionArr = codeArr;
    },
    toCurrentPage(code) {
      this.$router.push({
        path: `/controller_current/${code}`
      });
    },

    // 确认添加
    confirm() {
      if (!this.newSceneName) {
        nError("请输入场景名称");
        return false;
      }
      this.$axios
        .post(api.addElectricSceneByCodes, {
          name: this.newSceneName
        })
        .then(res => {
          nSuccess("添加成功");
          this.pageNum = 1;
          this.showAddScene = false;
          this.getPage();
        })
        .catch(errorHandler("添加失败"));
    },

    // 删除
    deleteLine(code) {
      this.$axios
        .post(api.deleteElectricSceneByCodes, {
          codes: code.join(",")
        })
        .then(res => {
          nSuccess("删除成功");
          this.getPage();
        })
        .catch(errorHandler("删除失败"));
    }
  },
  watch: {
    showAddScene() {
      this.newSceneName = "";
    }
  }
};
</script>

<style scoped>
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
.btn-box {
  display: flex;
  justify-content: flex-start;
}
</style>

<style lang="less">
.el-input--small .el-input__inner {
  line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/view/ElectronicManagement/DeviceSceneConfig/DeviceSceneConfig.vue